import { render, staticRenderFns } from "./SiteCustomInfoList.vue?vue&type=template&id=1801b26d&scoped=true"
import script from "./SiteCustomInfoList.vue?vue&type=script&lang=js"
export * from "./SiteCustomInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801b26d",
  null
  
)

export default component.exports